import Model from '../Model'

export default class Review extends Model {
  resource () {
    return 'reviews'
  }

  primaryKey () {
    return 'id'
  }
}
